import { forwardRef } from 'react';

import Icon from '../../../../Icon/Icon';

const BreadcrumbIndicator = forwardRef(({ icon }, ref) => (
  <div ref={ref} className="flex shrink-0 items-center">
    <Icon icon={icon} color="neutral" size={18} />
  </div>
));

BreadcrumbIndicator.displayName = 'BreadcrumbIndicator';

export default BreadcrumbIndicator;
